import { render, staticRenderFns } from "./CustomerPassword.vue?vue&type=template&id=2b2305ba&"
import script from "./CustomerPassword.vue?vue&type=script&lang=js&"
export * from "./CustomerPassword.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPassword.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports